import React from 'react';
import satsImg from '../../images/sats.png';

/* const trimUserName = (user) => {
    user = user.toLowerCase().trim();
    if (user.length > 0) {
        user = user.charAt(0).toUpperCase() + user.slice(1);
        const spaceIndex = user.indexOf(" ");
        if (spaceIndex > -1 && user.length > spaceIndex + 1) {
            user =
                user.substring(0, spaceIndex + 1) +
                user.charAt(spaceIndex + 1).toUpperCase() +
                user.substring(spaceIndex + 2);
        }
    }
    if (user.length > 20) {
        return user.slice(0, 20) + "...";
    } else {
        return user;
    }
}; */
const trimUserName = (user) => {
    user = user.toLowerCase().trim();
    if (user.length > 0) {
        user = user.charAt(0).toUpperCase() + user.slice(1);
        const spaceIndex = user.indexOf(" ");
        if (spaceIndex > -1 && user.length > spaceIndex + 1) {
            const secondPartLength = "";
            user = user.substring(0, spaceIndex + 1) + "*".repeat(secondPartLength);
        }
    }
    if (user.length > 20) {
        return user.slice(0, 20) + "...";
    } else {
        return user;
    }
};


const TopFive = (props) => {
    var { userName, totalRewardsInINR } = props?.userData;
    const user = trimUserName(userName);
    return (
        <div className="d-flex top-stackers" style={{ alignItems: 'center' }}>
            <span style={{ minWidth: '30px' }}>{props.rank}.</span>
            <span className="userName" style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user}</span>
            <div style={{ width: '55px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: '8px' }}>
                {/* <img className="sastImg mb-1" src={satsImg} alt={"icon"} /> */}
                <span className="userSats">₹{totalRewardsInINR}</span>
            </div>
        </div>
    );
};

export default TopFive;